import {mergeDeepRight} from 'ramda';
import React from 'react';
import {TextStyle, ViewStyle, TouchableOpacity} from 'react-native';
import {colors} from 'theme/Colors';
import {spacing, corner_radius} from 'theme/Units';
import {Text, Icon, IconPropType} from 'ui-kits';

interface UIButtonProps {
  title?: string;
  onPress?: () => void;
  leftIcon?: IconPropType['type'];
  rightIcon?: IconPropType['type'];
  size?: sizeTypes;
  textStyle?: TextStyle;
  style?: ViewStyle;
  iconSize?: number;
  variant?: keyof typeof variants;
}
type sizeTypes = 'lg' | 'md' | 'sm';

export const ActionButton: React.FC<UIButtonProps> = ({
  title,
  onPress,
  leftIcon,
  rightIcon,
  size = 'md',
  style: overrideStyle,
  textStyle: overrideTextStyle,
  iconSize = 14,
  variant = 'primary',
}) => {
  const styles = mergeDeepRight(
    mergeDeepRight(BASE, sizeStyles[size]),
    variants[variant],
  ) as any as baseStyleProps;

  return (
    <TouchableOpacity style={[styles.button, overrideStyle]} onPress={onPress}>
      {leftIcon ? <Icon size={iconSize} type={leftIcon} /> : null}
      {title ? (
        <Text style={[styles.text, overrideTextStyle]}>{title}</Text>
      ) : null}
      {rightIcon ? <Icon size={iconSize} type={rightIcon} /> : null}
    </TouchableOpacity>
  );
};

type baseStyleProps = {
  button: ViewStyle;
  text: TextStyle;
};

const BASE: baseStyleProps = {
  button: {
    borderColor: colors.palette.stroke,
    padding: spacing['2'],
    borderRadius: corner_radius['rounded-md'],
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing['2'],
  },
  text: {
    color: colors.palette.black,
    fontSize: 16,
    fontWeight: 500,
  },
};

type variantsType = {
  primary: baseStyleProps;
  secondary: baseStyleProps;
};

const variants: variantsType = {
  // default
  primary: {
    button: {...BASE.button, backgroundColor: colors.palette.brandBlue},
    text: {...BASE.text, color: 'white'},
  },
  secondary: {
    button: {
      ...BASE.button,
      backgroundColor: 'white',
      borderWidth: 1.5,
      borderColor: colors.palette.brandBlue,
      borderStyle: 'solid',
    },
    text: {...BASE.text, color: colors.palette.brandBlue},
  },
};

const sizeStyles: Record<sizeTypes, Partial<baseStyleProps>> = {
  lg: {
    button: {
      height: 48,
      fontSize: 20,
    },
  },
  md: {
    button: {
      height: 40,
      fontSize: 18,
    },
  },
  sm: {
    button: {
      height: 32,
      fontSize: 14,
    },
  },
};
